// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dl-dialog-counter-progress__content {
  padding-top: 12px;
}
.dl-dialog-counter-progress__text-progress {
  color: var(--g-color-text-complementary);
  margin-top: var(--g-spacing-1);
}`, "",{"version":3,"sources":["webpack://./src/ui/components/Progress/DialogCounterProgress.scss"],"names":[],"mappings":"AACI;EACI,iBAAA;AAAR;AAGI;EACI,wCAAA;EACA,8BAAA;AADR","sourcesContent":[".dl-dialog-counter-progress__content {\n  padding-top: 12px;\n}\n.dl-dialog-counter-progress__text-progress {\n  color: var(--g-color-text-complementary);\n  margin-top: var(--g-spacing-1);\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
